import React, { useCallback, useEffect, useState } from 'react'
import DiseaseDetail from '../components/DiseaseDetail'
import { DiagnosisResultScreenProps } from 'app/farmer360/routes/types'
import fetchDiseaseDetail from '../apis/fetchDiseaseDetail'
import { DiseaseDetailProps } from '../models/diagnosis'
import { Spinner } from '@dehaat/dds'
import { useAppSelector } from 'app/hooks/reduxHooks'
import { selectPlantixUId } from 'app/farmer360/store/app'
import { useRedirectOnRefresh } from '../hooks/useRedirectOnRefresh'
import { ROUTES as FARMER_360_ROUTES } from 'app/farmer360/routes/types'
import { rnNavigation } from 'app/utils/appConfig'

const DiagnosisResult = ({ route }: DiagnosisResultScreenProps) => {
  const { diseaseId,cropId,cropName } = route.params
  const [disease, setDisease] = useState<DiseaseDetailProps>()
  const [loading, setLoading] = useState(false)
  const plantixId = useAppSelector(selectPlantixUId)

  useRedirectOnRefresh({
    currentRoute: FARMER_360_ROUTES.DIAGNOSIS_RESULT,
    redirectRoute: FARMER_360_ROUTES.DISEASE_DIAGNOSIS,
    rnNavigation,
    skipRedirect: false,
  });

  const handleDiagnosisClick = useCallback(async () => {
    const response = await fetchDiseaseDetail(plantixId!, diseaseId)
    if (response) {
      setDisease(response)
    }
  }, [diseaseId, plantixId])

  useEffect(() => {
    setLoading(true)
    handleDiagnosisClick()
    setLoading(false)
  }, [handleDiagnosisClick])

  if (loading) {
    return <Spinner />
  }

  return <DiseaseDetail disease={disease!} cropId={cropId} cropName={cropName} />
}

export default DiagnosisResult
